import { useLocation, useNavigate, type Location } from "react-router-dom";
import {
  BankIcon,
  CorporateIcon,
  SlidersHorizontalIcon,
  TableOfContents,
  type TableOfContentsItem,
} from "@porchpass/ui";
import { useDealer } from "src/hooks/useDealer";

type DealerSettingsLocationState = {
  returnTo?: string;
};

const tocIcon = (Icon: typeof BankIcon, active: boolean) => (
  <Icon
    variant={active ? "bulk-rounded" : "stroke-rounded"}
    size={14}
    className={active ? "text-primary" : "text-text-med"}
  />
);

export default ({ currentSection }: { currentSection: string }) => {
  const navigate = useNavigate();
  const location = useLocation() as Location<DealerSettingsLocationState>;
  const { dealer_id } = useDealer();

  const items: TableOfContentsItem[] = [
    {
      id: "overview",
      label: "Overview",
      disabled: true,
      icon: (active) => tocIcon(CorporateIcon, active),
    },
    {
      id: "preferences",
      label: "Preferences",
      icon: (active) => tocIcon(SlidersHorizontalIcon, active),
    },
    {
      id: "lenders",
      label: "Lenders",
      icon: (active) => tocIcon(BankIcon, active),
    },
  ];

  return (
    <div className="mt-12">
      <TableOfContents
        items={items}
        size="large"
        activeId={currentSection}
        onItemClick={(id) => {
          void navigate(`/${dealer_id}/dealer-settings/${id}`, {
            replace: true,
            state: location.state,
          });
        }}
      />
    </div>
  );
};
